import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import PageHeader from "@/components/PageHeader";
import ErrorBoundary from "@/components/ErrorBoundary";
import { LayoutDashboard, Send, FileText, Server, ScrollText, ShieldOff, TrendingUp } from "lucide-react";

const TABS = [
  { to: "/bulk", end: true, label: "Dashboard", icon: LayoutDashboard, testid: "bulk-tab-dashboard" },
  { to: "/bulk/analytics", label: "Analytics", icon: TrendingUp, testid: "bulk-tab-analytics" },
  { to: "/bulk/campaigns", label: "Campaigns", icon: Send, testid: "bulk-tab-campaigns" },
  { to: "/bulk/templates", label: "Templates", icon: FileText, testid: "bulk-tab-templates" },
  { to: "/bulk/smtp-profiles", label: "SMTP Profiles", icon: Server, testid: "bulk-tab-profiles" },
  { to: "/bulk/suppressions", label: "Suppressions", icon: ShieldOff, testid: "bulk-tab-suppressions" },
  { to: "/bulk/logs", label: "Delivery Log", icon: ScrollText, testid: "bulk-tab-logs" },
];

export default function BulkShell() {
  return (
    <div className="flex flex-col h-full overflow-hidden" data-testid="bulk-shell">
      <PageHeader
        title="Bulk email"
        subtitle="SMTP profiles, templates, scheduled campaigns and per-recipient delivery log."
        eyebrow="Outreach"
      />
      <div className="border-b border-border bg-card/60 backdrop-blur px-4 lg:px-8 flex items-center gap-1 overflow-x-auto no-scrollbar" data-testid="bulk-tabs">
        {TABS.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            end={t.end}
            className={({ isActive }) =>
              `inline-flex items-center gap-1.5 px-3 py-2.5 text-xs font-mono uppercase tracking-widest border-b-2 transition-colors ${
                isActive
                  ? "border-emerald-brand text-emerald-brand"
                  : "border-transparent text-muted-foreground hover:text-foreground"
              }`
            }
            data-testid={t.testid}
          >
            <t.icon className="h-3.5 w-3.5" strokeWidth={1.75} />
            {t.label}
          </NavLink>
        ))}
      </div>
      <div className="flex-1 overflow-y-auto">
        <ErrorBoundary label="The Bulk Email section hit an error.">
          <Outlet />
        </ErrorBoundary>
      </div>
    </div>
  );
}
